import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { ResponseCatalog, RequestParams, CertificateModel } from 'Models'
import { SimpleResponse } from 'Types/simpleResponse'
import { StatusActModel, ActModel, KindActModel } from 'Pages/acts'

async function getAllActs(params?: RequestParams) {
	const res = await axiosDS().get<ResponseCatalog<ActModel>>(urls.acts.index, { params })
	return res.data
}

async function getAct(id: number, params?: RequestParams) {
	const res = await axiosDS().get<ActModel>(urls.acts.show.replace(':id', id.toString()), {
		params,
	})
	return res.data
}

async function getActStatuses() {
	const res = await axiosDS().get<StatusActModel[]>(urls.acts.statuses)
	return res.data
}
async function patchActUpdataStatus(act_id: number, status_slug: string) {
	const res = await axiosDS().patch<ActModel>(
		urls.acts.update_status.replace(':id', act_id.toString()),
		{ data: { status_slug } }
	)
	return res.data
}

async function partnerSignAct(act_ids: number[], code: string) {
	const res = await axiosDS().patch<ActModel[]>(urls.acts.partners_sign, {
		data: { act_ids, code },
	})
	return res.data
}

async function DSSignAct(act_id: number, ds_signature: string, certificate_info: CertificateModel) {
	const res = await axiosDS().patch<ActModel>(urls.acts.ds_sign.replace(':id', act_id.toString()), {
		data: { ds_signature, certificate_info },
	})
	return res.data
}

async function uploadActs(file) {
	const data = new FormData()
	data.append('[data][file]', file)
	const res = await axiosDS().post(urls.acts.upload, data)
	return res.data
}

async function uploadActsStatuses(file) {
	const data = new FormData()
	data.append('[data][file]', file)
	const res = await axiosDS().post(urls.acts.upload_paids, data)
	return res.data
}

export async function cancelActsPaids() {
	const res = await axiosDS().patch(urls.acts.cancel_paids)
	return res.data
}

async function createActSmsCode(act_ids: number[]) {
	const res = await axiosDS().post(urls.acts.create_sms_code, {
		data: { act_id: act_ids[0] },
	})
	return res.data
}

async function cancelActs(act_ids: number[], kind: string, message?: string) {
	const res = await axiosDS().patch(urls.acts.cancel, {
		data: { act_ids, kind, message },
	})
	return res.data
}

async function getCancelKindsActs(params?: RequestParams) {
	const res = await axiosDS().get<KindActModel[]>(urls.acts.cancel_kinds, { params })
	return res.data
}

async function deleteActs(act_ids: number[]) {
	const res = await axiosDS().delete(urls.acts.delete, { data: { data: { act_ids } } })
	return res.data
}

async function massDeleteActs(created_at_from?: string, created_at_to?: string) {
	const res = await axiosDS().delete(urls.acts.delete, {
		data: { data: { created_at_from, created_at_to } },
	})
	return res.data
}

async function onPartnerSignMassActs(created_at_from?: string, created_at_to?: string) {
	const res = await axiosDS().patch(urls.acts.on_partner_sign, {
		data: { created_at_from, created_at_to },
	})
	return res.data
}

async function restoreActs(act_ids: number[]) {
	const res = await axiosDS().patch(urls.acts.restore, { data: { act_ids } })
	return res.data
}

async function clearUnusedSms(partner_id: number) {
	const res = await axiosDS().delete(
		urls.acts.clear_sms.replace(':partner_id', partner_id.toString())
	)
	return res.data
}

async function unblockAct(act_id: number) {
	const res = await axiosDS().patch(urls.acts.unblock.replace(':act_id', act_id.toString()))
	return res.data
}
async function sendActProtocol(file: Blob, act_id: number, protocol_generation_error?: string) {
	const data = new FormData()
	data.append('[data][protocol]', file, `protocol_${act_id}.pdf`)
	if (protocol_generation_error) {
		data.append('[data][protocol_generation_error]', protocol_generation_error)
	}
	const res = await axiosDS().patch(
		urls.acts.send_act_protocol.replace(':act_id', act_id.toString()),
		data
	)
	return res.data
}

async function refundActs(act_ids: number[]) {
	const res = await axiosDS().patch(urls.acts.refund, { data: { act_ids } })
	return res.data
}

async function archiveActs(params?: RequestParams) {
	const res = await axiosDS().get(`${urls.acts.collection_archive}`, { params })
	return res.data
}

async function partnerCanSign(act_ids: number[]) {
	const res = await axiosDS().patch(`${urls.acts.partner_can_sign}`, { data: { act_ids } })
	return res.data
}

async function sendRefundEmails(act_ids: number[]) {
	const res = await axiosDS().post(urls.acts.send_refund_emails, { data: { act_ids } })
	return res.data
}

async function uploadPaymentOrders(file) {
	const data = new FormData()
	data.append('[data][file]', file)
	const res = await axiosDS().post(urls.acts.upload_payment_orders, data)
	return res.data
}

async function uploadThirdPartyActsAndInvoices(file) {
	const data = new FormData()
	data.append('[data][file]', file)
	const res = await axiosDS().post(urls.acts.upload_third_party_acts_and_invoices, data)
	return res.data
}

async function remarkActs(act_ids: number[], message: string) {
	const res = await axiosDS().patch(urls.acts.remark, {
		data: { act_ids, message },
	})
	return res.data
}

async function uploadReestr(file) {
	const data = new FormData()
	data.append('[data][file]', file)
	const res = await axiosDS().post(urls.acts.upload_reestr, data)
	return res.data
}

async function uploadPromotionReestr(file) {
	const data = new FormData()
	data.append('[data][file]', file)
	const res = await axiosDS().post(urls.acts.upload_promotion_reestr, data)
	return res.data
}
async function annulActs(act_ids: number[]) {
	const res = await axiosDS().patch<SimpleResponse>(urls.acts.annul_request, { data: { act_ids } })
	return res.data
}

export const ActsApi = {
	getAllActs,
	getAct,
	getActStatuses,
	patchActUpdataStatus,
	partnerSignAct,
	DSSignAct,
	uploadActs,
	uploadActsStatuses,
	createActSmsCode,
	cancelActs,
	getCancelKindsActs,
	deleteActs,
	onPartnerSignMassActs,
	massDeleteActs,
	restoreActs,
	sendActProtocol,
	cancelActsPaids,
	clearUnusedSms,
	unblockAct,
	refundActs,
	archiveActs,
	partnerCanSign,
	sendRefundEmails,
	uploadPaymentOrders,
	uploadThirdPartyActsAndInvoices,
	remarkActs,
	uploadReestr,
	annulActs,
	uploadPromotionReestr,
}
